import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
// ----------------- INTERFACE WITH QUOTA MENSUEL------------------------

export interface Offer {
  id: number;
  name: string;
  daily_emails: number;
  monthly_emails: number;
  yearly_emails: number;
  monthly_price: number;
  yearly_price: number;
  description?: string;
  stripe_price_monthly?: string;
  stripe_price_yearly?: string; 
  status: "active" | "inactive";
  stripe_product_id?: string;

}

export interface OfferWithSubscription extends Offer {
  stripe_subscription_id?: string;
  isSubscribed?: boolean;
}




// export interface Offer {
//   id: number;
//   name: string;
//   daily_emails: number;
//   monthly_emails: number;
//   price: number;
//   description?: string;
//   status: "active" | "inactive";
// }
// ------------------------CREATION OFFRE QUOTA ------------------------
export const createOffer = async (offerData: {
  name: string;
  daily_emails: number;
  monthly_emails: number;
  yearly_emails: number;
  monthly_price: number;
  yearly_price: number;
  description?: string;
}) => {
  const response = await axios.post(`${API_URL}/offer/create`, offerData, {
    headers: {
      Authorization: `${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

  console.log("Offre créée avec succès :", response.data);  
  return response.data;
};

// export const createOffer = async (offerData: {
//   name: string;
//   dailyEmails: number;
//   monthlyEmails: number;
//   price: number;
//   description?: string;
// }) => {
//   try {
//     const response = await axios.post(`${API_URL}/offer/create`, offerData, {
//       headers: {
//         Authorization: `${localStorage.getItem("token")}`,
//         "Content-Type": "application/json",
//       },
//     });
//     return response.data;
//   } catch (error: any) {
//     console.error("Erreur création offre :", error.response?.data || error.message);
//     throw new Error(error.response?.data?.error || "Erreur lors de la création de l'offre.");
//   }
// };

export const buyOffer = async (email: string, offerId: number) => {
  try {
    const response = await axios.post(`${API_URL}/offer/buy`, { email, offerId }, {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Erreur achat offre :", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Erreur lors de l'achat de l'offre.");
  }
};

export const getAllOffers = async (): Promise<Offer[]> => {
  try {
    const response = await axios.get(`${API_URL}/offer/all`, {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data.offers || [];
  } catch (error: any) {
    console.error("Erreur récupération offres :", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Erreur lors de la récupération des offres.");
  }
};

export const deleteOffer = async (id: number) => {
  try {
    const response = await axios.delete(`${API_URL}/offer/delete/${id}`, {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Erreur suppression offre :", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Erreur lors de la suppression de l'offre.");
  }
};

// ----------------------UPDATE OFFRE AVEC QUOTA ANNUEL---------------------
export const updateOffer = async (id: number, offerData: {
  name?: string;
  daily_emails?: number;
  monthly_emails?: number;
  yearly_emails?: number;
  monthly_price?: number;
  yearly_price?: number;
  description?: string;
}) => {
  const response = await axios.put(`${API_URL}/offer/update/${id}`, offerData, {
    headers: {
      Authorization: `${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

// export const updateOffer = async (id: number, offerData: {
//   name?: string;
//   dailyEmails?: number;
//   monthlyEmails?: number;
//   price?: number;
//   description?: string;
// }) => {
//   try {
//     const response = await axios.put(`${API_URL}/offer/update/${id}`, offerData, {
//       headers: {
//         Authorization: `${localStorage.getItem("token")}`,
//         "Content-Type": "application/json",
//       },
//     });
//     return response.data;
//   } catch (error: any) {
//     console.error("Erreur modification offre :", error.response?.data || error.message);
//     throw new Error(error.response?.data?.error || "Erreur lors de la modification de l'offre.");
//   }
// };

export const updateOfferStatus = async (id: number, status: "active" | "inactive") => {
  const response = await fetch(`${API_URL}/offer/status/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });

  if (!response.ok) throw new Error("Erreur lors de la mise à jour du statut");
  return response.json();
};

// ----------------------------------CREATE CHECKOUT SESSION WITH ANNUEL ----------------------------
export const createCheckoutSession = async (
  email: string, 
  offerId: number,
  period: "monthly" | "yearly"  
) => {
  try {
    const response = await axios.post(
      `${API_URL}/offer/create-checkout-session`,
      { email, offerId, period },
      {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; 
  } catch (error: any) {
    console.error("Erreur création session paiement :", error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || "Erreur lors de la création de la session de paiement."
    );
  }
};

export interface UserPurchase {
  user: {
    id: number;
    email: string;
    daily_email_quota: number;
    monthly_email_quota: number;
  };
  offer: {
    id: number;
    name: string;
    price: number;
    monthly_price: number;
    yearly_price: number;
    daily_emails: number;
    monthly_emails: number;
    yearly_emails: number;
  };
  purchasedAt: string;
  billing_period?: "monthly" | "yearly";
  invoiceUrl?: string;
}

export const getUsersByOffer = async (offerId: number): Promise<UserPurchase[]> => {
  try {
    const response = await axios.get(`${API_URL}/offer/${offerId}/users`, {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data.purchases || [];
  } catch (error: any) {
    console.error("Erreur récupération utilisateurs de l'offre :", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Erreur lors de la récupération des utilisateurs de l'offre.");
  }
};



export const getUserPurchasesByEmail = async (email: string): Promise<{ user: UserPurchase['user']; purchases: Array<{ offer: UserPurchase['offer']; stripe_subscription_id?: string }> }> => {
  try {
    const response = await axios.get(
      `${API_URL}/offer/user/${encodeURIComponent(email)}/purchases`,
      {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Erreur récupération achats utilisateur :",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.error ||
        "Erreur lors de la récupération des achats utilisateur."
    );
  }
};




export const claimFreeOffer = async (email: string) => {
  try {
    const response = await axios.post(
      `${API_URL}/offer/claim-free-offer`,
      { email },
      { headers: { Authorization: `${localStorage.getItem("token")}` } }
    );
    return response.data;
  } catch (error: any) {
    console.error("Erreur obtention offre gratuite :", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Erreur lors de l'obtention de l'offre gratuite.");
  }
};
export interface FreeOfferStatus {
  hasFreeOffer: boolean;
}


export const checkUserFreeOffer = async (email: string): Promise<FreeOfferStatus> => {
  try {
    const response = await fetch(`${API_URL}/offer/user/${email}/free-offer`);
    if (!response.ok) {
      throw new Error("Impossible de vérifier l'offre gratuite.");
    }

    const data: FreeOfferStatus = await response.json();
    return data;
  } catch (error: any) {
    console.error("Erreur checkUserFreeOffer:", error);
    return { hasFreeOffer: false }; 
  }
};


export const cancelSubscription = async (subscriptionId: string): Promise<{ success: boolean; message?: string }> => {
  try {
    const response = await axios.post(`${API_URL}/offer/cancel-subscription`, { subscriptionId });
    return response.data;
  } catch (error: any) {
    console.error("Erreur annulation abonnement :", error.response?.data || error.message);
    throw error;
  }
};